/* Vellora Lane cart drawer extras: shipping protection toggle */
(function () {
  if (window.__vlCartExtras) return;
  window.__vlCartExtras = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function post(path, body) {
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart request failed');
      return r.json();
    });
  }

  function render(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && state && state.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(state);
      if (state.item_count === 0) {
        drawer.classList.add('is-empty');
        var items = drawer.querySelector('cart-drawer-items');
        items && items.classList.add('is-empty', 'empty-cart');
      }
    } else {
      window.location.reload();
    }
  }

  document.addEventListener('change', function (e) {
    var el = e.target.closest && e.target.closest('[data-vl-prot]');
    if (!el) return;
    var wantOn = el.checked;
    el.disabled = true;
    el.closest('.vl-prot') && el.closest('.vl-prot').classList.add('is-busy');
    var req = wantOn
      ? post('cart/add.js', { items: [{ id: Number(el.dataset.variant), quantity: 1 }] })
      : post('cart/change.js', { id: el.dataset.key, quantity: 0 });
    req.then(render).catch(function () {
      el.checked = !wantOn;
      el.disabled = false;
      el.closest('.vl-prot') && el.closest('.vl-prot').classList.remove('is-busy');
    });
  });

  // If every real product is removed, take the protection line out too.
  function removeOrphan() {
    var o = document.querySelector('[data-vl-orphan]');
    if (!o || o.dataset.done) return;
    o.dataset.done = '1';
    post('cart/change.js', { id: o.dataset.key, quantity: 0 }).then(render).catch(function () {});
  }
  new MutationObserver(removeOrphan).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', removeOrphan);
})();
